PJQ.models.reports.NewReport = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.options.project && this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        return model;
    },
    getReportOptions: function () {
        let opts = this.get('options');
        return opts ? opts : {};
    },
    getFilters: function () {
        let reportOptions = this.getReportOptions(),
            filters = reportOptions.filters;
        return filters ? filters : {};
    },
    setFilters: function (filters) {
        let options = this.get('options') || {};
        options.filters = filters;
        this.set('options', options);
        this.trigger('change');
    },
    resetFilters: function () {
        let options = this.get('options') || {};
        options.filters = {};
        this.set('options', options);
    },
    setTimezone: function (timezone) {
        let options = this.get('options') || {};
        options.timezone = timezone;
        this.set('options', options);
    },
    getColumns: function () {
        let reportOptions = this.getReportOptions();
        return reportOptions.columns ? reportOptions.columns : {};
    },
    setColumns: function (columns) {
        let options = this.get('options') || {};
        options.columns = columns;
        this.set('options', options);
        this.trigger('change');
    },
    generate: function () {
        return new Promise((res, rej) => {
            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'generate'
                    }
                ]),
                data: this.toJSON()
            }).post().done(_.bind(function (response) {
                this.reportData = response;
                res(this.reportData);
            }, this));
        });
    },
    export: function (options = {format: 'pdf'}) {
        return new Promise((res, rej) => {
            let pData = this.toJSON();
            pData.reportResult = this.reportData;

            if (options.rows != null) {
                pData.reportResult.rows = options.rows;
            }

            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'export',
                        value: options && _.size(options.format) > 0 ? options.format : 'pdf'
                    }]),
                data: pData
            }).post().success(_.bind(function (response) {
                PJQ.files.downloadFile(response.url, {
                    isEndpoint: false
                });
                res(response);
            }, this));
        });
    }
});

PJQ.models.reports.CustomReport = PJQ.models.reports.NewReport.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.options.project && this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom'
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        return model;
    },
    getFilters: function () {
        return {};
    },
    getColumns: function () {
        return {};
    },
    export: function (projectId) {
        return new Promise((res, rej) => {
            let params = [];

            if (projectId) {
                params.push({
                    parameter: 'projectId',
                    value: projectId
                });
            }
            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'custom',
                        value: this.id
                    },
                    {
                        endpoint: 'export'
                    }], params),
                data: {
                    options: this.attributes.options
                }
            }).post().success(_.bind(function (response) {
                PJQ.files.downloadFile(response.url, {
                    isEndpoint: false
                });
                res(response);
            }, this)).fail(_.bind(function () {
                res();
            }, this))
        });
    },
    generatePreview: function (projectId) {
        let params = [];

        if (projectId) {
            params.push({
                parameter: 'projectId',
                value: projectId
            });
        }
        return new Promise((res, rej) => {
            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'custom',
                        value: this.id
                    },
                    {
                        endpoint: 'preview'
                    }], params),
                data: this.toJSON()
            }).post().success(_.bind(function (response) {
                res(response);
            }, this)).fail(_.bind(function () {
                res();
            }, this))
        });
    }
});

PJQ.models.reports.ReportOptions = PJQ.models.BaseModel.extend({});

PJQ.collections.reports.NewReportList = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.reports.NewReport,
    endpoint: function () {
        let params = [];
        if (this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                }
            ], params);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                }
            ], params);
        }
    }
});

PJQ.collections.reports.CustomReports = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.reports.CustomReport,
    endpoint: function () {
        let params = [];
        if (this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom'
                }
            ], params);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom'
                }
            ], params);
        }
    }
});